<template>
  <div class="myscore">
    <div class="title">
      <h2>成绩与证书</h2>
    </div>
    <div class="sea">
      <span>成绩列表</span>
      <div class="find">
        <!-- <div class="mod">
          <a-select
            class="selbtn"
            allow-clear
            placeholder="请选择所属模块"
            :notFoundContent="'暂无数据'"
            @change="indexSelect"
            v-decorator="[
              'modelname',
              { rules: [{ required: true, message: '请选择所属模块' }] },
            ]"
          >
            <a-select-option v-for="(item, index) in navlist" :key="index">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div> -->
        <input type="text" placeholder="请输入关键字" v-model="key" />
        <button class="ban" @click="findbtn">搜索</button>
      </div>
    </div>
    <div class="box">
      <a-table
        :columns="columns"
        :data-source="list"
        :rowKey="(record) => record.id"
        :pagination="pagination"
        @change="changePage"
        :locale="{ emptyText: '暂无数据' }"
        bordered
      >
        <div slot="model" slot-scope="index, record">
          <span v-if="record.model == 0">教学课堂</span>
          <span v-else>1+X服务平台</span>
        </div>
        <div slot="status" slot-scope="index, record">
          <span v-if="record.status == 0">否</span>
          <span v-else>是</span>
        </div>
        <div slot="action" class="tableAction" slot-scope="index, record">
          <span @click="getimg(record.imgUrl)">查看证书</span>
        </div>
      </a-table>
    </div>
    <a-modal
      title="证书预览"
      class="myscoremodal"
      width="1000px"
      :footer="null"
      :visible="flag"
      @cancel="flag = false"
      okText="下载"
    >
      <div class="md">
        <div class="bimg" width="889" height="624">
          <canvas id="myCanvas" width="889" height="624"> </canvas>
        </div>
      </div>
      <div class="he">
        <button class="downloadbtn" @click="godownload(bimg, isLogin)">
          下载<span></span>
        </button>
      </div>
    </a-modal>
    <!-- <div class="pagemodel">
      <pagination
        :pagination="pagination"
        @changePage="changePage"
      ></pagination>
    </div> -->
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    dataIndex: "index",
    width: 70,
  },
  {
    title: "考试名称",
    dataIndex: "examtitle",
    width: 200,
  },
  {
    title: "所属模块",
    scopedSlots: { customRender: "model" },
  },
  {
    title: "子模块",
    dataIndex: "submodel",
  },
  {
    title: "理论成绩",
    dataIndex: "thscore",
  },
  {
    title: "实操成绩",
    dataIndex: "Practice",
  },
  {
    title: "是否合格",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "操作",
    scopedSlots: { customRender: "action" },
  },
];

import { getscoreApi } from "@/request/api";
// import pagination from "@/components/common/pagination";
import axios from "axios";
export default {
  name: "myscore",
  data() {
    return {
      columns,
      flag: false,
      searchInfo: {
        keyword: "",
        type: "",
        page: 1,
        pageSize: 10,
      },
      pagination: { total: 0, pageSize: 10 },
      list: [],
      key: "",
      navlist: [{ name: "教学课堂" }, { name: "1+X服务平台" }],
      name: "",
      apiUrl: window.g.apiUrl,
      bimg: null,
      imgUrl: "",
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getToken(getscoreApi, this.searchInfo, (res) => {
        this.list = res.data.map((item, index) => ({
          index: (this.searchInfo.page - 1) * 10 + index + 1,
          examtitle: item.paperRecord.task && item.paperRecord.task.title,
          model: item.type,
          submodel: item.paperRecord.course && item.paperRecord.course.title,
          thscore: item.paperRecord.theoryScore,
          Practice: item.paperRecord.operationScore,
          status: item.paperRecord.passed,
          imgUrl: item.imgUrl,
        }));
        // this.pagination.total = this.list.length;
        console.log(this.list);
      });
    },
    changePage(currentPage) {
      this.searchInfo.page = currentPage;
      this.init();
    },
    indexSelect(data) {
      // console.log(data)
      this.searchInfo.type = data;
      this.init();
    },
    getimg(imgUrl) {
      this.flag = true;
      this.imgUrl = imgUrl;
      this.bimg = imgUrl;
      var img = new Image();
      img.src = this.imgUrl;
      img.onload = () => {
        var convas = document.getElementById("myCanvas");
        var ctx = convas.getContext("2d");
        ctx.drawImage(img, 0, 0, 889, 624);
        ctx.rotate((-30 * Math.PI) / 180); // 证书预览初始偏转角度
        for (let i = 0; i < 40; i++) {
          ctx.font = "26px microsoft yahei";
          ctx.fillStyle = "rgba(0,0,0,0.2)";
          ctx.fillText(
            "证书预览               证书预览              证书预览              证书预览              证书预览              证书预览              证书预览              证书预览              证书预览              证书预览              证书预览              证书预览              证书预览              证书预览              证书预览              证书预览              证书预览              证书预览              证书预览              证书预览             ",
            -1500 + i * 70,
            i * 70 - 450
          );
        }
        ctx.rotate((30 * Math.PI) / 180); // 把证书预览             偏转角度调整为原来的，不然他会一直转
      };
    },
    godownload(imgUrl) {
      axios({
        url: this.apiUrl + "certificate/download",
        method: "post",
        data: { imgUrl: imgUrl },
        responseType: "blob",
      }).then((res) => {
        if (!res) {
          return;
        }
        let url = window.URL.createObjectURL(res.data);
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", "证书.jpg");
        document.body.appendChild(link);
        link.click();
      });
    },
    findbtn() {
      // console.log(this.key)
      this.searchInfo.keyword = this.key;
      // console.log(this.searchInfo.keyword)
      this.init();
    },
  },
};
</script>
<style >
.myscore .ant-table table {
  text-align: center;
}
.myscore thead {
  display: table-header-group;
  vertical-align: middle;
  border-color: inherit;
  text-align: center;
  font-weight: 600;
  font-size: 16px;
}
.myscore .ant-table-bordered .ant-table-thead > tr > th,
.myscore .ant-table-bordered .ant-table-tbody > tr > td {
  border-right: 1px solid #e8e8e8;
  text-align: center;
}
.myscore .ant-table-thead > tr > th {
  color: #333;
  font-weight: 600;
  font-size: 14px;
  /* background-color: #eaeef7; */
  height: 30px;
}
.myscore .ant-table-bordered .ant-table-tbody {
  background: #fff;
}
.myscore .ant-table-pagination.ant-pagination {
  text-align: center;
  margin: 0px auto;
  margin-top: 50px;
}
.myscore .ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 10px 10px;
}

.myscoremodal .ant-modal {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  -webkit-font-feature-settings: "tnum";
  font-feature-settings: "tnum";
  position: relative;
  top: 100px;
  width: auto;
  margin: 0 auto;
  padding-bottom: 24px;
  width: 1000px !important;
  height: 813px;
}
.myscoremodal .ant-modal-title {
  margin: 0;
  color: #333;
  font-weight: 600;
  font-size: 20px;
  line-height: 36px;
}
.myscoremodal .ant-btn:nth-child(1) {
  outline: 0;
  display: none;
}
.myscoremodal .ant-btn:nth-child(2) {
  outline: 0;
  border: 0;
  border-radius: 3px;
  width: 162px;
  height: 45px;
  border-radius: 3px;
  /* background:url("../assets/myscoredownload2.png") ; */
  background-size: cover;
  background-color: #f1ce48;
  font-size: 18px;
}
.myscoremodal .ant-modal-close-x {
  display: block;
  width: 56px;
  height: 56px;
  font-size: 25px;
  font-style: normal;
  line-height: 56px;
  text-align: center;
  text-transform: none;
  text-rendering: auto;
}
.myscore .ant-modal-footer {
  padding: 10px 16px;
  text-align: center;
  /* border-top: 1px solid #e8e8e8; */
  border-radius: 0 0 4px 4px;
}
.myscoremodal .ant-modal-body {
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
  background-color: #f0f0f0;
  margin: 0 auto;
  text-align: center;
}
.myscoremodal .md {
  text-align: center;
  background: #f0f0f0;
  padding-top: 15px;
  padding-bottom: 15px;
}
.myscoremodal .he {
  height: 60px;
  line-height: 60px;
  padding-top: 10px;
}
.myscoremodal .he .downloadbtn {
  width: 140px;
  height: 40px;
  line-height: 40px;
  margin: 0 auto;
  background-color: #f1ce48;
  border-radius: 3px;
  color: #fff;
  border: 0;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
}
.myscoremodal .downloadbtn span {
  background: url("../../assets/mine/trainingdownload.png") no-repeat;
  width: 12px;
  height: 15px;
  z-index: 333;
  margin-left: 5px;
}
</style>
<style lang="stylus" scoped>
.myscore {
  margin-bottom: 100px;

  .title {
    height: 45px;
    line-height: 45px;
    overflow: hidden;
    border-bottom: 1px solid #eff2f2;

    h2 {
      height: 45px;
      line-height: 45px;
      margin-left: 30px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }
  }

  .sea {
    height: 45px;
    margin-left: 30px;
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: space-between;

    span {
      color: #333;
      font-size: 16px;
    }

    .find {
      display: flex;
      margin-right: 30px;

      .mod {
        width: 204px;
        height: 35px;
        line-height: 35px;
        margin-right: 24px;

        .selbtn {
          width: 100%;
          height: 100%;
        }
      }

      input {
        outline: none;
        width: 220px;
        height: 35px;
        border: solid 1px #d4d4d4;
        text-indent: 8px;
      }

      .ban {
        outline: none;
        width: 60px;
        height: 35px;
        background-color: #f1ce48;
        color: #333;
        font-size: 14px;
        cursor: pointer;
        border: 0;
      }
    }
  }

  .nav {
    display: flex;
    margin-top: 20px;
    height: 45px;
    line-height: 45px;
    margin-left: 12px;

    li {
      width: 150px;
      background: pink;
      margin-right: 20px;
      text-align: center;
    }

    li:last-child {
      margin-right: 0;
    }
  }

  .box {
    margin-top: 30px;
    margin-left: 30px;
    margin-right: 30px;
  }

  .pagemodel {
    margin-top: 30px;
    padding-top: 30px;
  }
}
</style>
